import React from 'react';
import { History } from 'history';
import { Input, InputDate, InputEmail, InputFile, InputMultiline, InputSelect, Layout, InputSwitch, InputPicklist } from '../../components';
import BaseView from '../base/base-view.component'; 
import Model from './personalinfo-model';  //editable..
import AddressList from '../address/address-list.component';
import CivilnumberList from '../civilnumber/civilnumber-list.component';
import ScheduleChecklist from '../schedule/schedule-checklist.component';
import AppService from '../../services/app.service';

interface IProps { 
    history: History;
    root?: string;
    caption?: string;
    personalinfotypeType?: string;
    disableBackButton?: boolean;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class PersonalinfoView extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
    }

    private onLoad = (data: any) => {
        this.setState({datarow:  data});
    }

    render() {
        return (
            //editable..
            <BaseView history={this.props.history} caption={this.props.caption} 
                model={Model} endPointFilter={Model.endPointFilter2(this.props.personalinfotypeType)} onLoad={this.onLoad} disableBackButton={this.props.disableBackButton} disableCard>              
                
                <Layout history={this.props.history} content={[
                    {caption: 'Details', child: 
                    <>
                        <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} readOnly/>
                        <Input name='name' label='Name' value={this.state.datarow.name} readOnly/>
                        <InputMultiline name='description' label='Description' value={this.state.datarow.description} readOnly/>
                        {AppService.isAppFullVersion() &&
                        <InputPicklist name='owner' label='Owner' value={this.state.datarow.owner} caption={this.state.datarow.ownerCaption} readOnly/>
                        } 
                        <InputPicklist name='personalinfotype' label='Type' value={this.state.datarow.personalinfotype} caption={this.state.datarow.personalinfotypeCaption} readOnly/>
                        <Input name='phone' label='Phone' value={this.state.datarow.phone} readOnly/>
                        <InputEmail name='email' label='Email' value={this.state.datarow.email} readOnly/>
                        <InputPicklist name='birthplace' label='Place of Birth' value={this.state.datarow.birthplace} caption={this.state.datarow.birthplaceCaption} readOnly/>
                        <InputDate name='birthdate' label='Date of Birth' value={this.state.datarow.birthdate} disableTime readOnly/>
                        <InputSelect name='gender' label='Gender' value={this.state.datarow.gender} options={Model.optionGender} error={this.state.errors?.gender} readOnly/>
                        <InputFile name='imageUrl' label='Photo' value={this.state.datarow.imageUrl} type='image' readOnly/>
                        {this.state.datarow.personalinfotypeType === 'employee' &&
                        <>
                        <InputPicklist name='division' label='User' value={this.state.datarow.division} caption={this.state.datarow.divisionCaption} readOnly/>
                        <InputPicklist name='schedule' label='Schedule List' value={this.state.datarow.schedule} caption={this.state.datarow.scheduleCaption} readOnly={this.state.datarow.schedule? false: true} disableAutoClose >
                            <ScheduleChecklist history={this.props.history} currentId={this.state.datarow.schedule} readOnly disableBackButton/>
                        </InputPicklist>
                        </>
                        }
                        <InputPicklist name='user' label='User' value={this.state.datarow.user} caption={this.state.datarow.userCaption} readOnly/>
                    </>
                    },

                    {caption: 'Addresses', child: 
                    this.state.datarow.id > 0 && this.props.history &&
                        <AddressList history={this.props.history} root={this.props.root} parentId={this.state.datarow.id} actions={['view']} disableBackButton disableCard/>
                    },

                    {caption: 'Civil Numbers', child: 
                    this.state.datarow.id > 0 && this.props.history &&
                        <CivilnumberList history={this.props.history} root={this.props.root} personalinfoId={this.state.datarow.id} actions={['view']} disableBackButton disableCard/>
                    },

                    ]}
                />
                  
            </BaseView>
        );
    }
}